import { modalManager } from "global-stores/modal-manager";
import { makeStyles } from "hooks/makeStyles";
import { MODALS } from "lib/constants";
import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Icons, Typography, VIPButton } from "ui/shared";

const useStyles = makeStyles((theme) => ({
  translationHideAlertContainer: {
    maxWidth: 350,
    padding: `${theme.spacing(8)} ${theme.spacing(5)}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  hideButton: {
    border: 0,
    padding: theme.spacing(3.75),
    backgroundColor: theme.colors.background.paper.lighter,
    marginTop: theme.spacing(5),
  },
  vipButtonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  alertText: {
    marginTop: theme.spacing(6),
  },
}));

const TranslateVIPAlertModal = observer(() => {
  const css = useStyles();
  const { t } = useTranslation("all");

  return (
    <div className={css.translationHideAlertContainer}>
      <Icons.SadFace width={102} height={82} />
      <Typography
        size="subtitle1(18px)"
        align="center"
        className={css.alertText}
      >
        {t("all:trans_alert_limit")}
      </Typography>
      <Box mt={5} className={css.vipButtonContainer}>
        <VIPButton
          onClick={() => modalManager.close(MODALS.TRANSLATE_VIP_ALERT)}
        />
      </Box>
    </div>
  );
});

export default TranslateVIPAlertModal;
